<div class="p-4 md:p-6 max-w-7xl mx-auto">
  <!-- Encabezado -->
  <div class="mb-5">
    <h1 class="text-2xl font-semibold text-gray-800 flex items-center gap-2">
      <mat-icon>account_balance_wallet</mat-icon>
      Responsable por Wallet
    </h1>
    <p class="text-sm text-gray-500 mt-1">
      Consulta de solo lectura. Pega una dirección para ver a qué clientes está
      asignada, o pon el ID de un cliente para ver todas sus direcciones.
      Para el <em>riesgo</em> de una dirección, usa "Validar Wallet".
    </p>
  </div>

  <!-- Toggle de modo -->
  <div class="inline-flex rounded-lg border border-gray-200 bg-white p-1 mb-4">
    <button
      type="button"
      class="px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-1"
      [class.bg-green-600]="modo === 'wallet'"
      [class.text-white]="modo === 'wallet'"
      [class.text-gray-600]="modo !== 'wallet'"
      (click)="setModo('wallet')"
    >
      <mat-icon class="!text-base !w-4 !h-4">search</mat-icon>
      Buscar por wallet
    </button>
    <button
      type="button"
      class="px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-1"
      [class.bg-green-600]="modo === 'usuario'"
      [class.text-white]="modo === 'usuario'"
      [class.text-gray-600]="modo !== 'usuario'"
      (click)="setModo('usuario')"
    >
      <mat-icon class="!text-base !w-4 !h-4">person_search</mat-icon>
      Buscar por cliente
    </button>
  </div>

  <!-- Barra de búsqueda -->
  <form
    class="flex flex-col md:flex-row gap-3 md:items-end mb-6"
    (ngSubmit)="buscar()"
  >
    <div class="flex-1">
      <label class="block text-xs font-medium text-gray-500 mb-1">
        {{ modo === 'wallet' ? 'Dirección de wallet' : 'ID del cliente' }}
      </label>
      <input
        type="text"
        [(ngModel)]="termino"
        name="termino"
        [placeholder]="
          modo === 'wallet'
            ? 'Pega la dirección completa y presiona Buscar…'
            : 'Ej. 452'
        "
        class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-green-500"
      />
    </div>

    <button
      type="submit"
      [disabled]="loading"
      class="bg-green-600 text-white rounded-lg px-5 py-2 text-sm font-medium hover:bg-green-700 disabled:opacity-50 flex items-center gap-1"
    >
      <mat-icon class="!text-base !w-4 !h-4">search</mat-icon>
      Buscar
    </button>

    <button
      type="button"
      (click)="limpiar()"
      class="border border-gray-300 text-gray-600 rounded-lg px-4 py-2 text-sm hover:bg-gray-50"
    >
      Limpiar
    </button>
  </form>

  <!-- Cargando -->
  <div *ngIf="loading" class="text-center py-10 text-gray-500 text-sm">
    <mat-icon class="animate-spin">progress_activity</mat-icon>
    <p class="mt-2">Consultando…</p>
  </div>

  <!-- ══════════ MODO WALLET → USUARIOS ══════════ -->
  <ng-container *ngIf="!loading && resultadoWallet as res">
    <!-- Resumen -->
    <div class="bg-white border border-gray-200 rounded-lg p-4 mb-4">
      <p class="text-xs text-gray-500 mb-1">Dirección consultada</p>
      <p class="font-mono text-sm text-gray-800 break-all">
        {{ res.address }}
        <button
          type="button"
          class="ml-1 text-gray-400 hover:text-gray-700 align-middle"
          (click)="copiar(res.address)"
          title="Copiar"
        >
          <mat-icon class="!text-sm !w-4 !h-4">content_copy</mat-icon>
        </button>
      </p>
      <p class="text-sm text-gray-600 mt-2">
        <strong>{{ res.totalUsuarios }}</strong>
        {{ res.totalUsuarios === 1 ? 'cliente' : 'clientes' }} ·
        <strong>{{ res.totalRegistros }}</strong>
        {{ res.totalRegistros === 1 ? 'registro' : 'registros' }}
      </p>
    </div>

    <!-- Alerta de wallet compartida -->
    <div
      *ngIf="walletCompartida"
      class="bg-amber-50 border border-amber-200 text-amber-800 rounded-lg p-3 mb-4 text-sm flex items-start gap-2"
    >
      <mat-icon class="!text-base !w-4 !h-4 mt-0.5">warning</mat-icon>
      <span>
        Esta dirección está cargada por <strong>{{ res.totalUsuarios }}</strong>
        clientes distintos.
      </span>
    </div>

    <!-- Sin resultados -->
    <div
      *ngIf="res.usuarios.length === 0"
      class="text-center py-10 text-gray-500 text-sm border border-dashed border-gray-300 rounded-lg"
    >
      <mat-icon class="!text-4xl !w-10 !h-10 text-gray-300">search_off</mat-icon>
      <p class="mt-2">Ningún cliente tiene esta dirección asignada.</p>
      <p class="text-xs mt-1">
        Revisa que esté completa y sin caracteres de más.
      </p>
    </div>

    <!-- Un bloque por cliente -->
    <div
      *ngFor="let u of res.usuarios"
      class="bg-white border border-gray-200 rounded-lg mb-3 overflow-hidden"
    >
      <div
        class="px-4 py-3 border-b border-gray-100 flex flex-wrap items-center gap-x-3 gap-y-1"
      >
        <span
          class="text-xs px-2 py-0.5 rounded-full border"
          [ngClass]="claseEstado(u.activo)"
        >
          {{ u.activo ? 'Cliente activo' : 'Cliente inactivo' }}
        </span>
        <span class="font-medium text-gray-800">
          {{ nombreCompleto(u.nombre, u.apellidos) }}
        </span>
        <span class="text-sm text-gray-500">ID {{ u.usuarioId }}</span>
        <span *ngIf="u.numeroId" class="text-sm text-gray-500">
          · {{ u.tipoId }} {{ u.numeroId }}
        </span>
        <span *ngIf="u.email" class="text-sm text-gray-500 break-all">
          · {{ u.email }}
        </span>
        <button
          type="button"
          class="ml-auto text-xs text-green-700 hover:underline flex items-center gap-1"
          (click)="verWalletsDe(u.usuarioId)"
        >
          <mat-icon class="!text-sm !w-4 !h-4">list</mat-icon>
          Ver todas sus wallets
        </button>
      </div>

      <ul class="divide-y divide-gray-100">
        <li
          *ngFor="let r of ordenarRegistros(u.registros)"
          class="px-4 py-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm"
        >
          <mat-icon
            class="!text-base !w-4 !h-4 text-gray-400"
            [title]="etiquetaOrigen(r.origen)"
          >
            {{ iconoOrigen(r.origen) }}
          </mat-icon>
          <span class="text-gray-600">{{ etiquetaOrigen(r.origen) }}</span>
          <span *ngIf="r.alias" class="text-gray-800">· {{ r.alias }}</span>
          <span *ngIf="r.red" class="text-gray-500">· {{ r.red }}</span>
          <span
            class="text-xs px-2 py-0.5 rounded-full border"
            [ngClass]="claseEstado(r.activa)"
            [title]="r.motivoInactiva || ''"
          >
            {{ r.activa ? 'Wallet activa' : 'Wallet inactiva' }}
          </span>
          <span *ngIf="!r.activa && r.motivoInactiva" class="text-xs text-gray-500">
            ({{ r.motivoInactiva }})
          </span>
        </li>
      </ul>
    </div>
  </ng-container>

  <!-- ══════════ MODO USUARIO → WALLETS ══════════ -->
  <ng-container *ngIf="!loading && resultadoUsuario as res">
    <!-- Ficha del cliente -->
    <div class="bg-white border border-gray-200 rounded-lg p-4 mb-4">
      <div class="flex flex-wrap items-center gap-x-3 gap-y-1">
        <span
          class="text-xs px-2 py-0.5 rounded-full border"
          [ngClass]="claseEstado(res.usuario.activo)"
        >
          {{ res.usuario.activo ? 'Cliente activo' : 'Cliente inactivo' }}
        </span>
        <span class="font-medium text-gray-800">
          {{ nombreCompleto(res.usuario.nombre, res.usuario.apellidos) }}
        </span>
        <span class="text-sm text-gray-500">ID {{ res.usuario.usuarioId }}</span>
        <span *ngIf="res.usuario.numeroId" class="text-sm text-gray-500">
          · {{ res.usuario.tipoId }} {{ res.usuario.numeroId }}
        </span>
        <span *ngIf="res.usuario.email" class="text-sm text-gray-500 break-all">
          · {{ res.usuario.email }}
        </span>
      </div>
      <p class="text-sm text-gray-600 mt-2">
        <strong>{{ res.totalRegistros }}</strong>
        {{ res.totalRegistros === 1 ? 'wallet' : 'wallets' }} ·
        <strong>{{ res.totalActivas }}</strong> activas
      </p>
    </div>

    <!-- Sin resultados -->
    <div
      *ngIf="res.registros.length === 0"
      class="text-center py-10 text-gray-500 text-sm border border-dashed border-gray-300 rounded-lg"
    >
      <mat-icon class="!text-4xl !w-10 !h-10 text-gray-300">
        account_balance_wallet
      </mat-icon>
      <p class="mt-2">Este cliente no tiene wallets cripto registradas.</p>
    </div>

    <!-- Lista de wallets -->
    <div
      *ngIf="res.registros.length"
      class="bg-white border border-gray-200 rounded-lg overflow-hidden"
    >
      <ul class="divide-y divide-gray-100">
        <li *ngFor="let r of res.registros" class="px-4 py-3">
          <div class="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm mb-1">
            <mat-icon
              class="!text-base !w-4 !h-4 text-gray-400"
              [title]="etiquetaOrigen(r.origen)"
            >
              {{ iconoOrigen(r.origen) }}
            </mat-icon>
            <span class="text-gray-600">{{ etiquetaOrigen(r.origen) }}</span>
            <span *ngIf="r.alias" class="text-gray-800">· {{ r.alias }}</span>
            <span *ngIf="r.red" class="text-gray-500">· {{ r.red }}</span>
            <span
              class="text-xs px-2 py-0.5 rounded-full border"
              [ngClass]="claseEstado(r.activa)"
            >
              {{ r.activa ? 'Activa' : 'Inactiva' }}
            </span>
            <span
              *ngIf="!r.activa && r.motivoInactiva"
              class="text-xs text-gray-500"
            >
              ({{ r.motivoInactiva }})
            </span>
            <span class="text-xs text-gray-400 ml-auto">
              {{ formatearFecha(r.creadoEn) }}
            </span>
          </div>
          <p class="font-mono text-xs text-gray-700 break-all">
            {{ r.address }}
            <button
              type="button"
              class="ml-1 text-gray-400 hover:text-gray-700 align-middle"
              (click)="copiar(r.address)"
              title="Copiar"
            >
              <mat-icon class="!text-sm !w-4 !h-4">content_copy</mat-icon>
            </button>
            <button
              type="button"
              class="ml-1 text-green-700 hover:underline text-xs align-middle"
              (click)="verUsuariosDe(r.address)"
            >
              ¿quién más la tiene?
            </button>
          </p>
        </li>
      </ul>
    </div>
  </ng-container>
</div>
